import * as Yup from "yup";

export const badlaCreateSchema = Yup.object().shape({
  script: Yup.object().required("Select Any script"),
});

export const instrumentInsfoSchema = Yup.object().shape({
  duty: Yup.number().required("Duty is required."),
  diffrenceValue: Yup.number().required("difference value is required."),
});

export const badlaHistorySchema = Yup.object().shape({
  badla: Yup.string().required("badla is required"),
  // date: Yup.string().trim().required("date is required"),
  // endDate: Yup.number().required("end date is required"),
  // startDate: Yup.number().required("start date value is required"),
  type: Yup.object().required("type is required"),
});

export const badlaOrderSchema = Yup.object().shape({
  reference: Yup.string().trim().required("Reference is required"),
  // openingAmount: Yup.number().min(0).required("openingAmount is required"),
  duty: Yup.number().min(0).required("duty is required"),
  // badlaType: Yup.object().required("Badla is required"),
  // settingName: Yup.string().,
  // badla: Yup.mixed().nullable(),

  comexInstrument: Yup.object().required("comexInstrument is required"),
  comexType: Yup.string().trim().required("comexType is required"),
  comexQty: Yup.number()
    .min(1, "Quantity must be at least 1")
    .required("Comex quantity is required"),
  comexPrice: Yup.number()
    .min(0, "Price must be at least 0")
    .required("Comex price is required"),
  // comexBroType: Yup.object().required("Comex brokerage type is required"),
  // comexBroAmount: Yup.number().min(0, "Brokerage amount must be at least 0"),

  dgcxQty: Yup.number()
    .min(1, "Quantity must be at least 1")
    .required("DGCX quantity is required"),
  dgcxPrice: Yup.number()
    .min(0, "Price must be at least 0")
    .required("DGCX price is required"),
  // dgcxType: Yup.mixed().nullable(),
  // dgcxBroAmount: Yup.number().min(0, "Brokerage amount must be at least 0"),
  // dgcxBroType: Yup.mixed().required("DGCX brokerage type is required"),
  // dgcxInstrument: Yup.mixed().nullable(),
  // dgcxDetail: Yup.mixed().nullable(),
  // dgcxLastBuyPrice: Yup.number().min(0, "Last buy price must be at least 0"),
  // dgcxLastSellPrice: Yup.number().min(0, "Last sell price must be at least 0"),

  mcxQty: Yup.number()
    .min(1, "Quantity must be at least 1")
    .required("MCX quantity is required"),
  mcxPrice: Yup.number()
    .min(0, "Price must be at least 0")
    .required("MCX price is required"),
  // mcxType: Yup.mixed().nullable(),
  // mcxBroAmount: Yup.number().min(0, "Brokerage amount must be at least 0"),
  // mcxBroType: Yup.mixed().required("MCX brokerage type is required"),
  // mcxInstrument: Yup.mixed().nullable(),
  // mcxDetail: Yup.mixed().nullable(),
  // mcxLastBuyPrice: Yup.number().min(0, "Last buy price must be at least 0"),
  // mcxLastSellPrice: Yup.number().min(0, "Last sell price must be at least 0"),
});

export const openingAmountSchema = Yup.object().shape({
  openingAmount: Yup.number().min(0).required("required"),
});

export const differenceSchema = Yup.object().shape({
  comexDifference: Yup.number().min(0).required("Comex Difference is required"),
  mcxDifference: Yup.number().min(0).required("Mcx Difference is required"),
  dgcxDifference: Yup.number().min(0).required("Dgcx Difference is required"),
});
